module.exports = __webpack_public_path__ + "static/media/signed.c7107856.svg";